export class $$LiveTransform {
  $$getIsDone() {}

  $$done() {}

  $$update(option) {}

  $$append(option) {}

  $$merge(option) {}
}
